import { Button, Col, Form, Input, notification, Row, Typography } from 'antd';
import axios from 'axios';
import React from 'react';

const { TextArea } = Input;
const { Title, Text } = Typography;

const ContactUs = () => {
    const [form] = Form.useForm();

    const handleSubmit = async (values) => {
        try {
            const response = await axios.post('https://app.auxrideshare.com/api/v1/contact-us/', values);
            console.log('Success:', response.data);
            notification.success({
                message: 'Success',
                description: 'Your message has been sent successfully!',
            });
        } catch (error) {
            console.error('Error:', error);
            notification.error({
                message: 'Error',
                description:
                    'There was an error sending your message. Please try again later.',
            });
        }
    };

    const onFinish = (values) => {
        console.log('Received values of form: ', values);
        handleSubmit(values);
    };

    return (
        <div>
            <div style={HeaderStyle}>
                <Title style={{ color: '#8A41D9' }}>Contact Us</Title>
            </div>

            <Row justify="center" style={{ padding: '20px' }}>
                <Col xs={24} sm={20} md={16} lg={12}>
                    <Text
                        style={{
                            fontSize: '19px',
                            fontWeight: '400',
                            color: '#030303',
                            textAlign: 'center',
                            display: 'block',
                            marginBottom: '20px',
                        }}
                    >
                        Our team is here to help with any inquiries or bookings. Contact
                        us today and experience the best services!
                    </Text>

                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        form={form}
                        style={{ background: '#fff', padding: '20px', borderRadius: '8px' }}
                    >
                        <Form.Item
                            label="Name"
                            name="Name"
                            colon={false}
                            rules={[{ required: true, message: 'Please input your name!' }]}
                        >
                            <Input placeholder="Name" />
                        </Form.Item>

                        <Form.Item
                            label="Phone Number"
                            name="PhoneNumber"
                            colon={false}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your phone number!',
                                    pattern:
                                        /^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
                                    message: 'Enter a valid phone number',
                                },
                            ]}
                        >
                            <Input placeholder="Phone Number" />
                        </Form.Item>

                        <Form.Item
                            label="Email"
                            name="Email"
                            colon={false}
                            rules={[
                                {
                                    required: true,
                                    type: 'email',
                                    message: 'Please input a valid email!',
                                },
                            ]}
                        >
                            <Input placeholder="Email" />
                        </Form.Item>

                        <Form.Item label="Message" name="Message" colon={false}>
                            <TextArea placeholder="Message" rows={4} />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                style={ButtonStyle}
                                type="primary"
                                htmlType="submit"
                                onClick={() => form.submit()}
                                block
                            >
                                Send
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

const ButtonStyle = {
    backgroundColor: '#8A41D9',
    fontSize: '15px',
    height: '40px',
    padding: '12px 24px',
    borderRadius: '3px',
    fontWeight: '500',
};

const HeaderStyle = {
    paddingTop: '240px',
    paddingBottom: '120px',
    backgroundImage:
        'url(https://auxriders.com/wp-content/uploads/2024/06/Untitled-design-84.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    textAlign: 'center',
};

export default ContactUs;
